import styled from "@emotion/styled";

export const ReplacementReviewHeader = styled.h1(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	...theme.project.typography.heading.h5
}));

export const ReplacementReviewReasonContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "20px"
}));

export const ReplacementReviewReasonHeader = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	width: "100%",
	marginBottom: "8px",
	color: theme.project.colors.fontColors.main,
	h2: {
		margin: 0,
		...theme.project.typography.subtitle.subtitle1
	}
}));
